import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './AppRouter';
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<React.StrictMode data-id="element-354">
    <AppRouter data-id="element-355" />
  </React.StrictMode>);